import { Box, Card } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import LoanBank from 'components/icons/LoanBank';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

interface Props {
	bankDetails?: any;
	showLoader?: boolean;
	onClickHandler: (...args: any[]) => void;
}
const BankDetails: React.FC<Props> = ({ bankDetails, showLoader, onClickHandler }) => {
	const type = 'MPIN';
	const [mPinLength, setMpinLength] = useState<number>(0);
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		const mPin = bankDetails?.CredsAllowed?.find((data: any) => data?.CredsAllowedSubType === String(type));
		setMpinLength(mPin?.dLength);
	}, [bankDetails]);

	return (
		<div className="my5">
			<Card className="p5" onClick={onClickHandler}>
				<div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
					<div style={{ width: '10%' }}>
						{bankDetails?.bank_logo ? (
							<img src={bankDetails?.bank_logo} width={'32px'} height={'32px'} />
						) : (
							<LoanBank />
						)}
					</div>
					<div
						className="mx5"
						style={{
							display: 'flex',
							justifyContent: 'flex-start',
							width: '70%',
						}}>
						<div>
							<p className="Light200 grey-dark">{bankDetails?.name?.toUpperCase() || 'NA'}</p>
							<p className="semiBold200 black">
								**** **** {bankDetails?.account?.substring(bankDetails?.account.length - 4)}
							</p>
							<>
								{bankDetails?.mbeba === 'Y' ? (
									<Box
										style={{
											background: '#F1F9F3',
											borderRadius: '4px',
											padding: '3px 10px',
											marginTop: '5px',
											width: '90px',
										}}>
										<p className="semiBold200 success uppercase">{languageData.UPI_PIN_EXIST}</p>
									</Box>
								) : (
									<Box style={{ background: '#FCF4F5', borderRadius: '5px', padding: '3px 10px', marginTop: '5px' }}>
										<p className="semiBold200 danger">
											{mPinLength}&nbsp;{languageData.DIGIT_UPI_PIN_NOT_EXIST}
										</p>
									</Box>
								)}
							</>
						</div>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default BankDetails;
